import { lazy } from 'react';

const RELOAD_FLAG = 'chunkReloadedAt';

// React.lazy, plus one automatic page reload if a page's code fails to download.
// After a deploy, a tab opened earlier still asks for the old chunk file names,
// which no longer exist; reloading picks up the new build. The flag stops a reload
// loop when the failure is a real network problem.
export default function lazyWithRetry(importer) {
	return lazy(() =>
		importer()
			.then(module => {
				try {
					sessionStorage.removeItem(RELOAD_FLAG);
				} catch (e) {}
				return module;
			})
			.catch(error => {
				let reloadedRecently = false;
				try {
					const last = Number(sessionStorage.getItem(RELOAD_FLAG));
					reloadedRecently = last && Date.now() - last < 10000;
					if (!reloadedRecently) sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
				} catch (e) {
					reloadedRecently = true;
				}
				if (!reloadedRecently) {
					window.location.reload();
					// Keep Suspense showing its fallback until the reload happens.
					return new Promise(() => {});
				}
				throw error;
			})
	);
}
